(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.accordion-wrapper.active').forEach(function (accordion) {
      accordion.querySelector('.accordion-content').style.maxHeight =
        accordion.querySelector('.accordion-content').scrollHeight + 'px';
    });
  });

  document.addEventListener('click', function (event) {
    const title = event.target.closest('.accordion-title');
    if (!title) return;

    const accordion = title.closest('.accordion-wrapper');
    if (!accordion) return;

    const content = accordion.querySelector('.accordion-content');
    const isActive = accordion.classList.contains('active');

    document.querySelectorAll('.accordion-wrapper').forEach(function (acc) {
      acc.classList.remove('active');
      acc.querySelector('.accordion-content').style.maxHeight = null;
    });

    if (!isActive) {
      accordion.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-read-more"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const button = event.target.closest('.js-more-button');
    if (!button) return;

    const wrapper = button.closest('.js-collection-read-more');
    if (!wrapper) return;

    const isExpanded = wrapper.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slider-component"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('slider-component').forEach(component => {
      const desktopSlides = component.getAttribute('data-desktop-slides') || 5;
      const tabletSlides = component.getAttribute('data-tablet-slides') || 3;
      const mobileSlides = component.getAttribute('data-mobile-slides') || 1.3;
      const desktopGap = parseInt(component.getAttribute('data-desktop-gap')) || 20;
      const mobileGap = parseInt(component.getAttribute('data-mobile-gap')) || 20;
      const mobileCenterSlides = component.getAttribute('data-mobile-center-slides') === 'true';
      const slideLoop = component.getAttribute('data-loop') == "false" ? false : true;

      const swiperEl = component.querySelector('.mySwiper');
      if (!swiperEl) return;

      new Swiper(swiperEl, {
        centeredSlides: mobileCenterSlides,
        slidesPerView: mobileSlides,
        spaceBetween: mobileGap,
        a11y: { enabled: false },
        loop: slideLoop,
        navigation: {
          nextEl: component.querySelector('.swiper-button-next'),
          prevEl: component.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            centeredSlides: false,
            spaceBetween: desktopGap,
            slidesPerView: tabletSlides
          },
          990: {
            centeredSlides: false,
            spaceBetween: desktopGap,
            slidesPerView: desktopSlides
          }
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
